import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {StarRatingDto} from "./dto/star-rating.dto";
import {FormBuilder, FormControl, Validators} from "@angular/forms";

@Component({
  selector: 'shared-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss',
})
export class StarRatingComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() config: StarRatingDto;
  @Input() isOpenNotes: boolean;
  @Output() value = new EventEmitter<number>();
  @Output() otherValue = new EventEmitter<string>();
  valueSet: number;
  otherValueSet: string;
  ratingGiven: number;
  @ViewChild('notesEl') notesEl: ElementRef;
  constructor() {}

  ngOnInit(): void {
    if (this.config === undefined) {
      this.config = {isRequired: false, initialValue: 0, initialOtherValue: "", withOtherValue: false, isRequiredOtherValue: false}
    }
    if (this.config.initialValue) {
      this.valueSet = this.config.initialValue
    }
    if (this.config.initialOtherValue) {
      this.otherValueSet = this.config.initialOtherValue
    }
  }

  onOpenNotes(): void {
    if (this.config.withOtherValue) {
      this.isOpenNotes = !this.isOpenNotes;
    }
  }

  onNotesChange(value: string): void {
    this.otherValue.emit(value)
  }

  onRatingSet(rating: number): void {
    this.value.emit(rating)
    this.ratingGiven = rating;
    if (this.config.withOtherValue){
      this.isOpenNotes = true;
      setTimeout(()=>{ // this will make the execution after the above boolean has changed
        this.notesEl.nativeElement.focus();
      },0);
    }
  }

  onBlur() {
    setTimeout(() => {
      this.isOpenNotes = false;
    }, 300)
  }
}
